var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: "22pt",
    fill: "none",
    viewBox: "0 0 18 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.731a8 8 0 1 1 16 0M9 9.885A4.308 4.308 0 1 0 9 1.27a4.308 4.308 0 0 0 0 8.615"
  })));
};
export default SvgUser;